<template>
	<div>
		<table class="table">
			<thead>
				<tr>
					<th colspan="6">Andamento costi</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th>Anno</th>
					<th>Energia</th>
					<th>Normativa</th>
					<th>Totale</th>
					<th>Variazione</th>
					<th>Variazione €</th>
				</tr>
				<tr v-for="(item, index) in years" :key="index">
					<th>{{ item.year }}</th>
					<td>{{ item.energy.value }}</td>
					<td>{{ item.normativa.value }}</td>
					<td>{{ item.total.value }}</td>
					<td v-if="index == 0" :rowspan="years.length" class="text-center" style="vertical-align: middle;">
						<template v-if="index == 0 && diff != null">
							<h3 class="nowrap"><span>{{ diffSign }}</span>{{ diff }}%</h3>
						</template>
					</td>
					<td v-if="index == 0" :rowspan="years.length" class="text-center" style="vertical-align: middle;">
						<template v-if="index == 0 && diffAmount != null">
							<h3 class="nowrap"><span>{{ diffSign }}</span>{{ diffAmount }}€</h3>
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<p>* Variazioni rispetto ad anno precedente</p>
	</div>
</template>
<script>
import utils from '../../../utilsMixin';
export default {
	name: "CostsTable",
	mixins: [utils],
	props: ['data', 'consumption', 'year'],
	created() {

	},
	computed: {
		years() {
			return this.data.filter(item => item.energy != null && item.normativa != null).map(item => { 
				return {
					year: item.year,
					energy: {
						raw: item.energy / 1000000,
						value: this.formatPrecision(item.energy / 1000000, 3)
					},
					normativa: {
						raw: item.normativa / 1000000,
						value: this.formatPrecision(item.normativa / 1000000, 3)
					},
					total: {
						raw: (item.energy + item.normativa) / 1000000,
						value: this.formatPrecision((item.energy + item.normativa) / 1000000, 3)
					}
				}
			})
		},
		yearsConsumption() {
			return this.consumption.filter(item => item.value != null).map(item => {
				return {
					year: item.year,
					value: item.value ? item.value / 1000 : 0
				}
			})
		},
		diff() {
			const yearValue = this.years.find(item => item.year == this.year)
			const preYearValue = this.years.find(item => item.year == this.year - 1)

			if (!yearValue || !preYearValue || preYearValue.total.raw == 0) {
				return null
			}

			return ((yearValue.total.raw - preYearValue.total.raw) / preYearValue.total.raw * 100).toFixed(2)
		},
		diffSign() {
			if (this.diff > 0) {
				return '+'
			}
			return ''
		},
		diffAmount() {
			try {
				const yearValue = this.years.find(item => item.year == this.year)
				const preYearValue = this.years.find(item => item.year == this.year - 1)

				if (!yearValue || !preYearValue || preYearValue.total.raw == 0) {
					return null
				}

				const yearConsumptionValue = this.yearsConsumption.find(item => item.year == this.year)
				const preYearConsumptionValue = this.yearsConsumption.find(item => item.year == this.year - 1)

				if (!yearConsumptionValue || !preYearConsumptionValue || preYearConsumptionValue.value == 0) {
					return null
				}

				const yearAmount = yearConsumptionValue.value * yearValue.total.raw
				const preYearAmount = preYearConsumptionValue.value * preYearValue.total.raw

				// returns the difference in euros (converts MWh to kWh)
				return this.formatPrecision((yearAmount - preYearAmount) * 1000, 2)
			} catch (e) {
				console.log(e)
				this.$notify({
					type: "error",
					text: e.message,
					title: 'Errore',
				});
				return null
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Tables/CostsTable.vue